(function($, undefined) {
	
	'use strict';
	var utils;
	var XMLUtils;
	var imageSelector;
	
	var cache = {
		"answer" : null	
	};
	
	var validateImageSelector = function() {
		var item = $(this);
		if (!item.hasClass('error') && !item.hasClass('success')) {
			item.closest('.image-selector-ctn').addClass('processing');
			var clickedAnswer = item.find('.image').attr('src');
			
			getCorrectAnswer(function(correctAnswer) {
				item.closest('.image-selector-ctn').removeClass('processing');
				if (clickedAnswer === correctAnswer) {
					item.addClass('success');
					updateUIRightAnswer();
				}
				else {
					item.addClass('error');
					updateUIWrongAnswer();
				}
				$('.exercise-detail-ctn').trigger('exercise-state-change');
			});
		}
	};
	
	var updateUIWrongAnswer = function() {
		var newTriesLeft = 3;
		if ($('.exercise-tries-left')) {
			var currentTries = parseInt($('.exercise-tries-left .num').first().text());
			var newTriesLeft = currentTries - 1;
			
			if (newTriesLeft > 0) {
				$('.exercise-tries-left .num').text(newTriesLeft);
			}
		}
		
		if (!$('.exercise-tries-left') || newTriesLeft <= 0) {
			$('.image-selector-ctn-inner').find('.show-right-answer-btn').removeAttr('disabled');
			$('.items-selector-items-wrapper').addClass('disabled');
			if ($('.exercise-tries-left')) {
				$('.exercise-tries-left .tries-text').text($('.exercise-tries-left .normal-text').attr('data-zero-tries-left-text'));
			}
		}
	};
	
	var updateUIRightAnswer = function() {
		$('.image-selector-ctn-inner').find('.show-right-answer-btn').hide();
		$('.save-exercise-btn').removeAttr('disabled');
	};
	
	var showValidAnswer = function() {	
		getCorrectAnswer(function(correctImage) {
			$('.image-selector-item').filter(function() {
				return $(this).find('.image').attr('src') === correctImage;
			}).addClass('success');
			updateUIRightAnswer();
		});
	};
	
	var getCorrectAnswer = function(callback) {
		if (cache.answer !== null) {
			callback(cache.answer);
		} 
		else {
			utils.getGenData($('.exercise-detail-ctn').attr('data-id'), function(json) {
				var xml = XMLUtils.stringToXML(json);
				var imagesTag = xml.getElementsByTagName('Images')[0];
				var list = imagesTag.getAttribute('list');
				
				var answer = null;
				var listArray = list.split(',');
				for (let key in listArray) {
					var item = listArray[key];
					var itemSplit = item.split('|*|');
					if (itemSplit[1] == 'true') {
						answer = itemSplit[0];
					}
				}
				
				cache.answer = answer;
				callback(answer);
			});
		}
	};
	
	var init = function () {
		XMLUtils = Fw.component.models().XMLUtils;
		utils = Fw.component.models().utils;
		imageSelector = $('.image-selector-item');
		
		imageSelector.on('click', validateImageSelector);
		$('.image-selector-ctn .show-right-answer-btn').on('click', showValidAnswer);
		
		if ($('.exercise-text-zone-ctn').length  > 0) {
			utils.loadLexiqueText($('.exercise-text-zone-ctn .text-zone').html(), function(text) {
				var element = $('.exercise-text-zone-ctn .text-zone');
				element.html(text);	
				element.removeClass('processing hide');
			});
		}
	};
	
	$(window).ready(function () {
		init();
	});
	
})(jQuery);
